import React from 'react';
import TDB2Logo from "../../../images/background/tdbfileDtl.png"

const TDBFileStatic = (props) => {
    return (
        <div>
            <div style={{ marginTop: 8 }}>
                <img src={TDB2Logo} alt='' style={{ width: '100%', borderRadius: 4 }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 14, fontWeight: 400, marginBottom: 16 }}>
                <p>Та цалингаа Худалдаа Хөгжлийн Банкаар дамжуулан шилжүүлдэг бол энэхүү нэмэлтийг худалдаж авснаар Худалдаа Хөгжлийн Банкны шилжүүлгийн файлын форматаар цалингийн шилжүүлгийн файл авах боломжтой болох юм.
                </p>
            </div>
        </div>
    );
}

export default TDBFileStatic;